import './scss/catalog.scss';
import './script/switchTheme';
import './script/loadCatalogHeroSubject';
import './script/loadCatalog';
import './script/btnUp';
import './script/pagination';
